import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"

export const InsurerNetworkBanner = () => {
  const { t } = useTranslation()

  return (
    <Banner type="inline" variant="warning" className="mb-4" data-testid="insurer-network-banner">
      {t("episodeOfCare.progressNote.pointOfCare.insurerNetworkCareProviderRequired")}
    </Banner>
  )
}
